import { useEffect, useMemo } from "react";
import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  addSpaceBeforeCapital,
  currentDateString,
  ShowAlert,
  showConfirmationDialog,
} from "../../utils/functions";
import { OfferTypeEnum } from "../../stores/index.d";
import { IProductOffer } from "../../stores/productOffer";
import moment from "moment";

const cols: string[] = [
  "#",
  "Product",
  "Free Product",
  "Offer Type",
  "Discount %",
  "Multi Buy Qty",
  "Multi Buy Discount %",
  "Status",
  "Actions",
];

const ProductOfferListing = observer(() => {
  const { productOfferStore } = useStores();
  const { setEditOffer } = productOfferStore;
  const { deleteOffer, offers, fetchOffers } = productOfferStore;

  const getEnumNameByValue = (value: number): string | undefined => {
    return addSpaceBeforeCapital(OfferTypeEnum[value]);
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  const offerList = useMemo(() => {
    return offers;
  }, [offers]);

  const handleDelete = async (n: number) => {
    showConfirmationDialog(() => {
      deleteOffer(n, (res: boolean) => {
        if (res) {
          ShowAlert.Success("The item has been deleted.");
          fetchOffers();
        } else {
          ShowAlert.Error("Request failed. Please try again.");
        }
      });
    });
  };

  return (
    <>
      <table className="table table-responsive table-striped shadow-lg">
        <thead>
          <tr>
            {cols.map((c, i) => (
              <th
                scope="col"
                className="border-top-0 border-start-0 border-end-0 border-3 border-warning"
                key={i}
              >
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {offerList.map((offer: IProductOffer, i) => {
            const isActive = moment(offer.endDate).isSameOrAfter(
              currentDateString()
            );

            return (
              <tr key={offer.productOfferId}>
                <th scope="row">{i + 1}</th>
                <td>{offer.product?.productName}</td>
                <td>{offer.freeProduct?.productName || "-"}</td>
                <td>{getEnumNameByValue(offer.offerType)}</td>
                <td>
                  {offer.discountPercentage
                    ? `${offer.discountPercentage}%`
                    : "-"}
                </td>
                <td>{offer.multiBuyQuantity || "-"}</td>
                <td>
                  {offer.multiBuyDiscountPercentage
                    ? `${offer.multiBuyDiscountPercentage}%`
                    : "-"}
                </td>
                <td className={isActive ? "text-success" : "text-danger"}>
                  {isActive ? "Active" : "Expired"}
                </td>
                <td>
                  <div className="btn-group">
                    <button className="btn" onClick={() => setEditOffer(offer)}>
                      <FontAwesomeIcon icon={faEdit} className="text-primary" />
                    </button>
                    <button
                      className="btn"
                      onClick={() => handleDelete(offer.productOfferId)}
                    >
                      <FontAwesomeIcon icon={faTrash} className="text-danger" />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
          {!offerList?.length && (
            <tr>
              <th colSpan={8} className="text-center">
                No data available
              </th>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
});

export default ProductOfferListing;
